import { Icon } from "@iconify/react/dist/iconify.js";
import { AppContext } from "../../context/AppContext";
import React, { useState, useEffect, useContext,useRef } from "react";
import UploadDocModal from "../../modals/uploaddocModal";
import {
  getCaseDocuments,
  deleteCaseDocument,
  uploadDocument,
} from "../../APIs/caseDocumentApis";



const UploadedDocs = ({ selectedCase }) => {
  const [isuploadModelOpen, setisuploadModelOpen] = useState(false);
  const [documents, setDocuments] = useState([]);
  const fileInputRef = useRef(null);


  useEffect(() => {
    fetchDocuments(selectedCase?._id);
  }, [selectedCase]);

  function getFileName(url) {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname;
    const decodedPathname = decodeURIComponent(pathname);
    return decodedPathname.substring(decodedPathname.lastIndexOf("/") + 1);
  }

  const fetchDocuments = async (caseId) => {
    // if (!caseId) return;
    console.log("Fetching documents for case ID:", caseId);

    try {
      const data = await getCaseDocuments(caseId);
      console.log("Fetched documents:", data);
      setDocuments([...data]);
      // setDocuments(data);
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };
  const handleDelete = async (documentId) => {
    try {
      console.log("Deleting document with ID:", documentId);
      await deleteCaseDocument(documentId);
      setDocuments(documents.filter((doc) => doc._id !== documentId));
    } catch (error) {
      console.error("Error deleting document:", error);
    }
  };

  
  const handleDownload = (docUrl, docName) => {
    console.log("Downloading document:", docName, "from", docUrl);
    const newTab = window.open(docUrl, "_blank");
    if (!newTab) {
      console.error("Failed to open new tab. Make sure pop-ups are allowed.");
    }

    // const link = document.createElement("a");
    // link.href = docUrl;
    // link.download = docName;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };
  
 
//  const handleFileChange = async (event) => {
//   event.preventDefault();

//   if (!selectedCase?._id) {
//     console.error("No case selected.");
//     return;
//   }

//   const storedData = secureLocalStorage.getItem("loginCredentials");
//   if (!storedData?.user?.id) {
//     console.error("User ID not found in secureLocalStorage");
//     return;
//   }
//   const userId = storedData.user.id;

//   if (!event.target.files.length) {
//     console.error("No file selected.");
//     return;
//   }

//   const file = event.target.files[0];

//   // Create FormData for upload
//   const formData = new FormData();
//   formData.append("case_id", selectedCase._id);
//   formData.append("user_id", userId);
//   formData.append("file", file);

//   try {
//     const response = await uploadClientData(formData);
//     console.log("Client data uploaded:", response);
//     setisuploadModelOpen(true);
//     fetchDocuments(selectedCase._id); // Refresh the document list
//   } catch (error) {
//     console.error("Error uploading client data:", error);
//   }
// };
  const handleUpload = async (file) => {
    console.log("Selected Case:", selectedCase);
    if (!selectedCase?._id) {
      console.error("Error: No case selected for uploading the document.");
      return;
    }

    try {
      const response = await uploadDocument(file, selectedCase._id);
      console.log("Document uploaded successfully:", response);

      // setDocuments((prevDocuments) => [...prevDocuments, response]);
      fetchDocuments(selectedCase?._id); 
     
      // setTimeout(() => {
      //   fetchDocuments(selectedCase._id);
      // }, 2000);
      
    } catch (error) {
      console.error("Error uploading document:", error);
    }
  };
 


  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  }

  // const [documents, setDocuments] = useState([
  //   {
  //     name: "Document1.PDF",
  //     date: "October 5, 2024 - 2:00 PM",
  //   },
  //   {
  //     name: "Document2.PDF",
  //     date: "October 6, 2024 - 3:00 PM",
  //   },
  // ]);
  // const addDoc = () => {
  //   setisuploadModelOpen(true);
  // };

  return (
    <>
      <div className="bottom flex flex-col gap-[16px] drop-shadow-md rounded-[21px] px-[26px] sm-s:px-[20px] py-[13px] border-[rgba(255,255,255,0.28)] bg-[#F4F4F4] shadow-lg">
        <div className="performance flex justify-between items-center ">
          <p className="text-blue font-semibold large">Uploaded Documents</p>
          <div
            className="add-docs flex gap-[6px] items-center px-[15px] py-[14px] bg-[#D0ECF1] rounded-full cursor-pointer"
            // onClick={addDoc}
            onClick={() => setisuploadModelOpen(true)}
            // onClick={openFilePicker}
          >
            <Icon
              icon="material-symbols:upload"
              width="18"
              height="18"
              color="#14BBDA"
            />
            <p className="e-small light-blue-color">Add Document</p>
            {/* Hidden file input */}
            <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            // onChange={handleFileChange}
          />
          </div>
        </div>
        <div className="uploaded-docs-list flex flex-col gap-[12px] px-[10px]  max-h-[250px] overflow-y-auto">
          {/* {documents.map((doc, index) => ( */}

          {documents.map((doc) => (
            <div
              // key={index}
              key={doc.id}
              // key={doc._id} 
              className="doc-detail flex items-center justify-between bg-white rounded-[10px] px-[16px] py-[20px]"
            >
              <div className="flex flex-col gap-[6px]">
                <p className="medium text-darkGrey font-semibold">
                  {getFileName(doc.file)}
                </p>
                <p className="small txt-color font-medium">
                  {formatDate(doc.createdAt)}
                </p>
              </div>
              <div className="flex items-center gap-[6px]">
                <div
                  className="rounded-full bg-[#D0ECF1] p-[7px] cursor-pointer"
                  onClick={() =>
                    handleDownload(doc.file, getFileName(doc.file))
                  }
                >
                  <Icon
                    // icon="hugeicons:view"
                    icon="material-symbols:download"
                    width="22"
                    height="22"
                    color="#14BBDA"
                  />
                </div>
                <div
                  className="rounded-full bg-[#F4D4D2] p-[7px] cursor-pointer"
                  onClick={() => handleDelete(doc._id)}
                >
                  <Icon
                    icon="material-symbols-light:delete-outline"
                    width="22"
                    height="22"
                    color="red"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <UploadDocModal
        isuploadModelOpen={isuploadModelOpen}
        setisuploadModelOpen={setisuploadModelOpen}
        handleUpload={handleUpload}
      />
    </>
  );
};

export default UploadedDocs;
